/* © CNES */
import { apiConfiguration } from '../APIConfiguration';
import { authenticationAPI } from '../authentication/AuthenticateAPI';

/**
 * Get the API KEY from Keycloak.
 * @returns a Promise that will return a 200 status if the service has succeeded
 */
export const getApiKey = async (): Promise<any> => {
  let res: Response | undefined;
  if (process.env.NODE_ENV === 'production') {
    res = await fetch(
      `${apiConfiguration.authentication.url}/realms/${apiConfiguration.authentication.realm}/apikey?refresh=true`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...authenticationAPI.getAuthorizationHeaders(),
        },
      }
    );
  } else {
    res = new Response(
      JSON.stringify({
        creationDate: '2023-09-08T14:53:31.866343773Z',
        value: 'kcUzN2gz1imay7lsq2UZ0UhBNi7gnjaAey5hBwx506cRBmtAEr',
      })
    );
  }
  return res?.json();
};
